import { render, staticRenderFns } from "./Tarifs.vue?vue&type=template&id=30c5b1a0&"
import script from "./Tarifs.vue?vue&type=script&lang=js&"
export * from "./Tarifs.vue?vue&type=script&lang=js&"
import style0 from "./Tarifs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports